"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringMatcherContext = void 0;
function stringMatcherContext(ruleAttr) {
    var regex = new RegExp(ruleAttr);
    return function stringMatcher(runtimeAttr) {
        var regexMatches = regex.test(runtimeAttr);
        return regexMatches;
    };
}
exports.stringMatcherContext = stringMatcherContext;
